
import { Avatar } from "antd";
import { CloseOutlined } from "@ant-design/icons";



const ContactDetails = ({ contact, onClose }) => {
  return (
    <div className="contact-details">
      <div className="contact-header">
        <span>Contact Info</span>
        <CloseOutlined onClick={onClose} />
      </div>


      <div className="contact-body">
         <Avatar
          src={contact.image}
          size={100}
        >
         {(contact?.chatName || contact?.originalName || contact?.from || "?")?.charAt(0)}
        </Avatar>

        <h3>{contact?.chatName || contact?.originalName || contact?.from || "Unknown"}</h3>
        <p>{contact.phone}</p>

        <div className="contact-section">
          <strong>User's whatsapp profile name</strong>
          <p>{contact.originalName || "N.A"}</p>
        </div>
        <div className="contact-section">
          <strong>User Last Message</strong>
          <div>{contact.userActiveStatus || "Unknown"}</div>
at
          <div> {contact.lastIncomingTime
              ? new Date(contact.lastIncomingTime).toLocaleString()
              : "N/A"}
              </div>
        </div>

        <div className="contact-section">
          <strong>First Message</strong>
          <p>{contact.firstUserMessage || "No first message"}</p>
        </div>

        <div className="contact-section">
          <strong>Last Message Time</strong>
          <p>
            {contact.lastMessageTime
              ? new Date(contact.lastMessageTime).toLocaleString()
              : "N/A"}
          </p>
        </div>

        <div className="contact-section">
          <strong>Total Session Messages</strong>
          <p>{contact.sessionMessages || 0}</p>
        </div>

        <div className="contact-section">
          <strong>Template Messages</strong>
          <p>{contact.templateMessages || 0}</p>
        </div>
      </div>
    </div>
  );
};
export default ContactDetails;